import React, { Component } from "react";
import { connect } from "react-redux";
import { Draggable } from "react-beautiful-dnd";

import style from "./Tile.module.css";

import WorkoutCard from "../WorkoutCard/WorkoutCard";

import { dateFormater } from "../../assets/Js/DateFormater";

import { Spinner } from "../../Components/Spinner/Spinner";

const mapStateToProps = (state) => {
  return {
    numberOfWorkout: state.workoutApiCalled,
    calendarDateChanged: state.dateChanged,
    userData: state.userData,
  };
};

export default connect(
  mapStateToProps,
  null
)(
  class Tile extends Component {
    constructor(props) {
      super(props);

      let [day, month, date, year] = this.props.date.split(" ");

      this.state = {
        isLoading: false,
        showError: false,
        tileDay: day,
        tileMonth: month,
        tileDate: dateFormater(date),
        tileYear: year,
        tileToday: this.props.today,
        workoutData: [],
      };
    }

    static getDerivedStateFromProps(props, state) {
      let [day, month, date, year] = props.date.split(" ");

      return {
        ...state,
        tileDay: day,
        tileMonth: month,
        tileDate: dateFormater(date),
        tileYear: year,
        tileToday: props.today,
        selectedTrack: props.track,
        workouts: props.workouts,
        isTracksLoading: props.isTracksLoading,
      };
    }

    render() {
      const todaysTile =
        this.state.tileToday.month === this.state.tileMonth &&
        this.state.tileToday.date === this.state.tileDate;

      return (
        <div className={`tileContainer ${todaysTile ? "tileToday" : null}`}>
          <div className="text-left mb-2">{this.state.tileDay}</div>
          <div className="text-left mb-2">
            <span className="text-uppercase tileDate">
              {dateFormater(this.state.tileDate)}
            </span>
            <span className="tileItems ml-1">
              <small>
                {this.props.workouts ? this.props.workouts.length : 0} item
                {this.props?.workouts?.length > 1 ? "s" : ""}
              </small>
            </span>
          </div>
          <div
            className={`tileWorkoutContainer tertiaryScrollBar
              ${
                this.props.showSubscriptionEnded === "true"
                  ? "tileContianerHeight1"
                  : "tileContianerHeight2"
              }
              `}
          >
            <div className="workoutListBox">
              {this.props.isTracksLoading ? (
                this.props ? (
                  this.props.calendarDateChanged ? (
                    <div className={style.spinnerBox}>
                      <Spinner />
                    </div>
                  ) : this.props.workouts ? (
                    this.props.workouts.map((currVal, index) => {
                      return this.props.userData.Role === "owner" ? (
                        this.props.workouts[index] && (
                          <div>
                            <Draggable
                              draggableId={this.props.workouts[
                                index
                              ].TrackWorkoutId.toString()}
                              index={index}
                              key={this.props.workouts[
                                index
                              ].TrackWorkoutId.toString()}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <WorkoutCard
                                    key={index}
                                    workout={this.props.workouts[index].Workout}
                                    trackWorkoutId={
                                      this.props.workouts[index].TrackWorkoutId
                                    }
                                    tileDate={this.props.date}
                                  />
                                </div>
                              )}
                            </Draggable>
                          </div>
                        )
                      ) : (
                        <>
                          <WorkoutCard
                            key={index}
                            trackWorkoutId={
                              this.props.workouts[index].TrackWorkoutId
                            }
                            workout={this.props.workouts[index].Workout}
                            tileDate={this.props.date}
                          />
                        </>
                      );
                    })
                  ) : null
                ) : null
              ) : null}
              <WorkoutCard tileDate={this.props.date} />
            </div>
          </div>
        </div>
      );
    }
  }
);
